/**
 * Serialises a plain JSON-LD object into a <script type="application/ld+json">.
 * Safe for React 19 — data-controlled, not user-controlled.
 */
export default function StructuredData({ data }) {
    if (!data) return null;
    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        />
    );
}
